export interface WeatherData {
  temp: number;
  humidity: number;
  windSpeed: number;
  description: string;
  icon: string;
  shortDescription: string;
}

export interface IWeatherDataManager {
  fetchWeather(city: string): Promise<WeatherData>;
  getWeather(): WeatherData | null;
  isLoading(): boolean;
}

export class WeatherDataManager {
  private static instance: WeatherDataManager;
  private weather: WeatherData | null = null;
  private loading: boolean = true;
  private apiKey: string = process.env.REACT_APP_WEATHER_API_KEY
  
  private constructor() {
  }

  public static getInstance(): WeatherDataManager {
    if (!WeatherDataManager.instance) {
      WeatherDataManager.instance = new WeatherDataManager();
    }
    return WeatherDataManager.instance;
  }

  public async fetchWeather(city: string): Promise<WeatherData> {
    try {
      console.log(`apikey: ${this.apiKey}`);
      this.loading = true;
      const response = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${this.apiKey}&units=metric`
      );
      
      if (!response.ok) {
        throw new Error('Weather data not available');
      }

      const data = await response.json();
      
      this.weather = {
        temp: Math.round(data.main.temp),
        humidity: data.main.humidity,
        windSpeed: Math.round(data.wind.speed),
        description: data.weather[0].description,
        icon: data.weather[0].icon,
        shortDescription: data.weather[0].main
      };

      return this.weather;
    } catch (error) {
      throw error;
    } finally {
      this.loading = false;
    }
  }

  public getWeather(): WeatherData | null {
    return this.weather;
  }

  public isLoading(): boolean {
    return this.loading;
  }
}

export default WeatherDataManager;